import React, { memo, useContext } from "react";
import "./styles.scss";
import CloseButton from "Components/CloseButton";
import { useSelector } from "react-redux";
import Img from "Components/Img";
import { flag1, flag2 } from "Res/images";
import ModelNew from "Components/Model/ModelNew";
import DomainContext from "Context/DomainContext";

const getStatusColor = (status) => {
  if (status === true) return "#67CF14";
  if (status === false) return "#D80000";
  return "#808080";
};

const Social = ({ openModel, setOpenModel, statusData }) => {
  const { storeId } = useContext(DomainContext);
  const getHeaderData = useSelector(
    (state) => state?.getHeaderFooterData?.data?.header?.contactSection
  );

  const handleChatClick = (text) => {
    if (text === "Chat live ") {
      window?.Tawk_API?.toggle?.();
    }
  };

  const renderStatusDot = (headerText) => {
    let status;

    switch (headerText) {
      case "Bel de klantenservice":
        status = statusData?.phoneActiveWorkingStatus;
        break;
      case "Mail ons":
        status = statusData?.emailActiveWorkingStatus;
        break;
      case "Chat live ":
        status = statusData?.chatActiveWorkingStatus;
        break;
      case "Whatsapp ":
        status = statusData?.whatsappActiveWorkingStatus;
        break;
      default:
        status = null;
    }

    return (
      <div
        className="status absolute r-full overflow-hidden"
        style={{ backgroundColor: getStatusColor(status) }}
      />
    );
  };

  const renderPhoneNumbers = (item) => {
    if (!item?.phoneNumber || !item?.additionalPhoneNumber)
      return null;

    return (
      <>
        <p>
          <Img src={flag1} className="mr-2" />
          <a className="line-6" href={`tel:${item.phoneNumber}`}>
            {item.phoneNumber}
          </a>
        </p>
        <p>
          <Img src={flag2} className="mr-2" />
          <a className="line-6" href={`tel:${item.additionalPhoneNumber}`}>
            {item.additionalPhoneNumber}
          </a>
        </p>
      </>
    );
  };

  return (
    <ModelNew
      from="right"
      hideScroll={false}
      zindex={11}
      open={openModel}
      shadow={true}
      setOpen={setOpenModel}
      className="header__contact__sidebar"
    >
      <div className="sidebar__social w-1/1 h-1/1 px-4 sm-px-6 py-4">
        <div className="close__block tr flex right w-1/1">
          <CloseButton onClickFunction={() => setOpenModel(false)} />
        </div>

        <div className="sidebar__heading pb-3">
          <h1 className="fw-700 mb-2">
            {getHeaderData?.topContent?.headerText}
          </h1>
          <p className="line-7">
            {getHeaderData?.topContent?.subText}{" "}
            {getHeaderData?.topContent?.workingHours}
          </p>
        </div>

        <div className="flex col w-1/1 social__details">
          {getHeaderData?.contactDetails?.map((item, index) => {
            const { headerText, image, mailId, description, whatsappNumber, whatsappLinkNumber } = item.contactInfo;

            return (
              <div
                key={`social__sidebar${index}`}
                className={`flex gap-7 middle w-1/1 pt-4 pb-3 ${
                  headerText === "Chat live " ? "pointer chat__live" : ""
                }`}
                onClick={() => handleChatClick(headerText)}
              >
                <div className="icon__block__social flex-0 flex center">
                  <div className="socialicon__img flex relative">
                    <Img
                      src={image}
                      alt={`${storeId === 1 ? "Promofit" : "Expofit"} ${getHeaderData?.topContent?.headerText}`}
                    />
                    {image && renderStatusDot(headerText)}
                  </div>
                </div>

                <div className="flex-1 flex col gap-1 social__detail top">
                  <h3 className="fw-700">{headerText}</h3>
                  <div className="contact__block flex col left">
                    {renderPhoneNumbers(item?.contactInfo)}
                    {mailId && (
                      <p className="mail__text">
                        <a
                          className="line-6 text-underline"
                          href={`mailto:${mailId}`}
                          target="__blank"
                          rel="noopener noreferrer"
                          aria-label={`Send email to ${mailId}`}
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault();
                              window.location.href = `mailto:${mailId}`;
                            }
                          }}
                        >
                          {mailId}
                        </a>
                      </p>
                    )}
                    {description && <p>{description}</p>}
                    {whatsappNumber && (
                      <a
                        className="flex w-1/1 left line-6"
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`https://wa.me/${whatsappLinkNumber?.replace(/\s|-/g, "")}`}
                        aria-label={`Chat on WhatsApp with number ${whatsappNumber}`}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            window.location.href = `https://wa.me/${whatsappLinkNumber?.replace(/\s|-/g, "")}`;
                          }
                        }}
                      >
                        {whatsappNumber}
                      </a>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </ModelNew>
  );
};

export default memo(Social);
